/**
 * B_ChildWorld.js
 *
 * @경로 :
 * @목적 : 최상위 child 클래스
 * @설명 :
 * @진행 :
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Util from 'canvas/base/dev/util/B_Util';
import B_Define from 'canvas/base/dev/util/B_Define';
import B_Child from 'canvas/base/dev/child/base/B_Child';

const B_ChildWorld = (function(superclass){

	const $ = {

	};

	class B_ChildWorld extends superclass {

		constructor(obj) {
			super(obj);

			if (obj.CODMOS) this.CODMOS = obj.CODMOS;

			// [S] type 리스트 설정
			if(this.CODMOS.WORLD) {
				this.CODMOS.WORLD[this._id] = this;                  // 월드 객체 (world)
				this.CODMOS.WORLD.LIST.all[this._id] = this;         // 전체 배열 (all)
				if (this.CODMOS.WORLD.LIST[this._type]) {
                    this.CODMOS.WORLD.LIST[this._type][this._id] = this; // 타입 배열 (type)
				}
				if(this._isExist) {
					// [Case1] 'RealObject'
					this.CODMOS.WORLD.LIST.real[this._id] = this;    // 존재 배열
					this.CODMOS.WORLD.LIST.obj[this._id] = this;     // 객체 배열
				}
				else {
					// [Case2] 'UnrealObject'
					this.CODMOS.WORLD.LIST.unreal[this._id] = this;  // 존재 배열
				}
			}

			// [T]
			B_Util.print(B_Define.MESSAGE['CREATE_WORLD_OBJECT'] + ' ( id: ' + this._id + ' )');
		}

		// [F]

		// @OVERRIDING
		_remove() {
			super._remove();
			/**
			 * [ STEP ]
			 *
			 * 01. 참조되는 모든 링크 제거
			 * 02. [all ,real, unreal, obj] type 제거
			 * */

			// # 01.
			delete this.CODMOS.WORLD[this._id];
			delete this.CODMOS.WRAPPER[this._id];

			// # 02. all, real, unreal, obj, type
			let _aArr = this.CODMOS.WORLD.LIST.all;
			let _rArr = this.CODMOS.WORLD.LIST.real;
			let _uArr = this.CODMOS.WORLD.LIST.unreal;
			let _oArr = this.CODMOS.WORLD.LIST.obj;
			let _tArr = this.CODMOS.WORLD.LIST[this._type];

			for(let aKey in _aArr) { if(_aArr[aKey]._id == this._id) delete _aArr[aKey]; }
			for(let rKey in _rArr) { if(_rArr[rKey]._id == this._id) delete _rArr[rKey]; }
			for(let uKey in _uArr) { if(_uArr[uKey]._id == this._id) delete _uArr[uKey]; }
			for(let oKey in _oArr) { if (_oArr[oKey]._id == this._id) delete _oArr[oKey]; }
			for(let tKey in _tArr) { if(_tArr[tKey]._id == this._id) delete _tArr[tKey]; }
		}

	};



	B_Util.manageGetAndSet(B_ChildWorld, $);
	return B_ChildWorld;
});

export default B_ChildWorld;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/child/base/B_ChildWorld.js